import React from 'react';
import classnames from 'classnames';
import s from './BlurredBackground.scss';
export var BlurredBackground = function (_a) {
    var imageUrl = _a.imageUrl, _b = _a.clientSideBlur, clientSideBlur = _b === void 0 ? false : _b;
    return (React.createElement("div", { className: s['root'] },
        React.createElement("div", { className: classnames(s['image'], clientSideBlur && s['image-blurred']), style: {
                backgroundImage: "url('".concat(imageUrl, "')"),
            } })));
};
BlurredBackground.displayName = 'BlurredBackground';
export default BlurredBackground;
//# sourceMappingURL=BlurredBackground.js.map